export default __webpack_public_path__ + "static/media/CSI Lectionary_Home page Thumbnail.ec8add2f.jpg";